import React from 'react';

// Inline new-UAE-Dirham glyph sized to the surrounding text (em units) so it can
// sit right before an amount, e.g.  Dhs 234,354.
export const AedSymbol = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: '0.82em', height: '0.82em' }}
    className={`inline-block shrink-0 ${className}`}
    aria-hidden="true"
  >
    <path d="M9 4h2.5a7 7 0 0 1 0 16H9z" />
    <path d="M4.5 10H17" />
    <path d="M4.5 14H17" />
  </svg>
);

// Render a monetary amount with the official Dirham symbol prefix.
// Use ONLY in JSX display — string contexts (toasts, PDFs, WhatsApp) keep "AED".
export const Money = ({ value, digits = 0, className = '' }) => {
  const n = Number(value || 0);
  const s = n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return (
    <span className={`inline-flex items-center gap-0.5 whitespace-nowrap ${className}`}>
      <AedSymbol />{s}
    </span>
  );
};

export default Money;
